import {useEffect, useState} from 'react';
import {SFuncModal} from 'shj-components';
import {Col, DatePicker, Form, InputNumber, message, Row, Select, Spin, Switch} from 'antd';
import dayjs from "dayjs";
import { getNewInsurAccountsDetail, newInsurAccountsInsertConfBatch, newInsurAccountsUpdateConfigStatus } from "@/services/insureManagement.ts";
import {positiveDecimalAndSixIntRegExp} from "@/utils/regular.tsx";
import { getEnums, httpCompanyList } from '@/services/homeService';
import { useRequest } from 'ahooks';

const {Option} = Select;
const { RangePicker } = DatePicker;
export function addOrEditFn({fn, ...rest}) {
    const onClose = () => {
        dialog.destroy();
    };
    const dialog = SFuncModal({
        title: `${rest?.id ? '编辑' : '新增'}`,
        width: 600,
        vanish: true,
        content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
    });

    return dialog;
}

const ModalAddOrEditDom = ({onClose, fn, ...rest}) => {
    let {data: companyList = []} = useRequest<any, any>(httpCompanyList);
    const [form] = Form.useForm();
    const id = rest?.id
    const [loading, setLoading] = useState<any>(false);
    const [submitLoading, setSubmitLoading] = useState<boolean>(false)
    const [deductionMethod, setDeductionMethod] = useState<any>([])
    const initFn = async () => {
        if (id) {
            setLoading(true)
            getNewInsurAccountsDetail(id).then((res: any) => {
                if (res.startDate && res.endDate) {
                    res.timeDate = [dayjs(res.startDate), dayjs(res.endDate)]
                }
                setLoading(false)
                form.setFieldsValue({...res,id})
            })
        }
        const insurDeductionMethodEnum:any = await getEnums("plus-pm", "com.shj.saas.plus.pm.domain.insur.enums.InsurDeductionMethodEnum")
        setDeductionMethod(insurDeductionMethodEnum)
    }
    useEffect(() => {
        initFn()
    }, [])
    const onChange = (value) => {
        if (value[value.length - 1] === '0') {
            form.setFieldsValue({
                ['companyIds']: ['0'],
            })
        } else {
            value = value.filter(item => item !== '0')
            form.setFieldsValue({
                ['companyIds']: value,
            })
        }
    }
    // 提交
    const onFinish = () => {
        form.validateFields().then((values: any) => {
            if (Date.parse(values.startDate) >= Date.parse(values.endDate)) {
                message.error('开始时间不能大于等于结束时间')
                return false;
            }
            let newObj = {...values};
            newObj.startDate = values.timeDate ? dayjs(values.timeDate[0]).format('YYYY-MM-DD 00:00:00') : "";
            newObj.endDate = values.timeDate ? dayjs(values.timeDate[1]).format('YYYY-MM-DD 23:59:59') : "";
            if(!Array.isArray(values.companyIds)) {
                newObj.companyIds = [values.companyIds];
            }
            newObj.enabled = values.enabled === true ? 1 : 0;
            setSubmitLoading(true)
            const urlHttp = rest.id ? newInsurAccountsUpdateConfigStatus : newInsurAccountsInsertConfBatch;
            urlHttp({
                ...newObj,
            }).then((response: any) => {
                message.success(response?.message || "操作成功");
                fn?.();
                onClose?.();
            }).catch(() => {
                setSubmitLoading(false)
            });
        })
    };
    return (
        <SFuncModal.Content
            onCancel={onClose}
            onOk={onFinish}
            confirmLoading={submitLoading}>
            <Spin spinning={loading} tip="加载中...">
                <Form
                    form={form}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Row>
                        <Form.Item label={'id'} name={'id'} hidden></Form.Item>
                        <Col span={24}>
                            <Form.Item
                                label="门店"
                                name="companyIds"
                                rules={[{required: true, message: '请选择门店'}]}
                            >
                                <Select mode={'multiple'} placeholder={"请选择门店"} optionFilterProp="children" allowClear={true}
                                    onChange={(value: any) => onChange(value)}
                                        showSearch={true}>
                                    <Option key={-1} value={'0'}>通用</Option>
                                    {companyList && companyList.map((item, index) => (
                                        <Option key={index} value={item.orgId}>
                                            {item.companyName}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="金额（￥）"
                                name="amount"
                                rules={[
                                    {required: true, message: '请输入金额'},
                                    {required: false, message: '请输入最大6位正整数，正小数（小数位不超过2位）', pattern: positiveDecimalAndSixIntRegExp},
                                ]}
                            >
                                <InputNumber placeholder={"请输入金额"} precision={2} style={{width: '100%'}} max={999999.99}/>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="周期（月）"
                                name="numOfmonthPriod"
                                rules={[{required: true, message: '请输入周期（月）'}]}
                            >
                                <InputNumber placeholder={"请输入周期（月）"} precision={0} min={1} max={99}
                                             style={{width: '100%'}}/>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="警戒金额(￥)"
                                name="amountWarn"
                                rules={[
                                    {required: true, message: '请输入警戒金额'},
                                    {required: false, message: '请输入最大6位正整数，正小数（小数位不超过2位）', pattern: positiveDecimalAndSixIntRegExp},
                                ]}
                            >
                                <InputNumber placeholder={"请输入警戒金额"} precision={2} style={{width: '100%'}} max={999999.99}/>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="有效周期"
                                name="timeDate"
                                rules={[{required: true, message: '请选择有效周期'}]}
                            >
                                <RangePicker
                                    style={{width: '100%'}}/>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="扣费方式"
                                name="deductionMethod"
                                rules={[{required: true, message: '请选择扣费方式'}]}
                            >
                                <Select placeholder={"请选择扣费方式"} allowClear={true} showSearch={true}>
                                    {deductionMethod && deductionMethod.map((item, index) => (
                                        <Option key={index} value={item.key}>
                                            {item.description}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="状态" name="enabled" initialValue={true} valuePropName="checked">
                                <Switch checkedChildren="开" unCheckedChildren="关"/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        </SFuncModal.Content>
    );
};
